// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-wrapper[data-v-2880d971]{width:90%;max-width:714px}.st0[data-v-2880d971]{fill:url(#SVGID_1_)}.st1[data-v-2880d971]{fill:url(#SVGID_00000122691386389552051400000009324463607062572468_)}", ""]);
// Exports
module.exports = exports;
